import { useState, useEffect } from 'react';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Handle anchor scrolling after navigation
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  const scrollToChooser = () => {
    if (window.location.pathname === '/') {
      const element = document.getElementById('chooser');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = '/#chooser';
    }
  };

  const scrollToFAQ = () => {
    if (window.location.pathname === '/') {
      const element = document.getElementById('faq');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = '/#faq';
    }
  };

  return (
    <>
      {/* Navigation Header */}
      <nav className="sticky top-0 z-50 bg-[#0a1628]/95 backdrop-blur-sm border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 sm:gap-3 cursor-pointer">
            <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center flex-shrink-0">
              <img 
                src="https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/c5fcb1dbae29388464febce36e760d64.png" 
                alt="BullyProof My Life Shield Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <h1 className="text-white font-black text-base sm:text-xl md:text-2xl tracking-tight" style={{ fontFamily: "'Oswald', sans-serif" }}>
              BULLY PROOF MY LIFE
            </h1>
          </a>

          {/* Desktop Navigation Links */}
          <div className="hidden lg:flex items-center gap-8">
            <a 
              href="/" 
              className="text-gray-300 hover:text-white font-semibold text-base transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Home
            </a>
            <a 
              href="/about" 
              className="text-gray-300 hover:text-white font-semibold text-base transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              My $4,500 Mistake
            </a>
            <button
              onClick={scrollToFAQ}
              className="text-gray-300 hover:text-white font-semibold text-base transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              FAQ
            </button>
            <a
              href="/#chooser"
              className="bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold text-base px-6 py-3 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer inline-block"
            >
              GET THE SHIELD
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-[#0a1628] border-t border-white/5">
            <div className="px-4 py-4 space-y-3">
              <a 
                href="/" 
                className="block text-gray-300 hover:text-white font-semibold text-base py-2 transition-colors duration-300 cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </a>
              <a 
                href="/about" 
                className="block text-gray-300 hover:text-white font-semibold text-base py-2 transition-colors duration-300 cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                My $4,500 Mistake
              </a>
              <button
                onClick={() => {
                  scrollToFAQ();
                  setMobileMenuOpen(false);
                }}
                className="block w-full text-left text-gray-300 hover:text-white font-semibold text-base py-2 transition-colors duration-300 cursor-pointer"
              >
                FAQ
              </button>
              <a
                href="/#chooser"
                className="block w-full bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold text-base px-6 py-3 rounded-lg transition-all duration-300 cursor-pointer text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                GET THE SHIELD
              </a>
            </div>
          </div>
        )}
      </nav>

      <section className="py-12 sm:py-16 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Byline */}
          <div className="flex items-center gap-3 sm:gap-4 mb-6 sm:mb-8">
            <img 
              src="https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/dadaf59f289a861c44051d9874a96e48.jpeg"
              alt="Matt Theriault"
              className="w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover object-top flex-shrink-0"
            />
            <div>
              <p className="text-gray-300 text-sm">By Matt Theriault</p>
              <p className="text-gray-500 text-sm">5 Minute Read</p>
            </div>
          </div>

          {/* Headline */}
          <h2 className="text-3xl sm:text-5xl md:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            WHY I STOPPED FIGHTING FAIR.
          </h2>

          {/* Subhead */}
          <h3 className="text-xl sm:text-2xl md:text-3xl text-[#ef4444] font-semibold mb-6 sm:mb-8 leading-relaxed">
            I used to think a handshake meant something. Then I lost $4,500 learning that some people only respect leverage.
          </h3>
        </div>
      </section>
    </>
  );
}
